export const SERVICIOS_ITEMS = [
  { label: 'Ecotrim', path: '/ecotrim/' },
  { label: 'Geotrim', path: '/geotrim/' },
];

export const PARA_QUIEN_ITEMS = [
  {
    label: 'Instaladores e ingenierías energéticas',
    path: '/para-quien/instaladores-ingenierias-energeticas/',
  },
  {
    label: 'Fabricantes de baterías',
    path: '/para-quien/fabricantes-baterias/',
  },
  {
    label: 'Alimentación y frío industrial',
    path: '/para-quien/alimentacion-frio/',
  },
  {
    label: 'Cerámica y porcelánico',
    path: '/para-quien/ceramica-porcelanico/',
  },
  {
    label: 'Movilidad eléctrica',
    path: '/para-quien/movilidad-electrica/',
  },
  {
    label: 'Data centers',
    path: '/para-quien/data-centers/',
  },
];
